import { render, staticRenderFns } from "./warning.vue?vue&type=template&id=27a5df8f&scoped=true&"
import script from "./warning.vue?vue&type=script&lang=js&"
export * from "./warning.vue?vue&type=script&lang=js&"
import style0 from "./warning.vue?vue&type=style&index=0&id=27a5df8f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5df8f",
  null
  
)

export default component.exports